/*
 * @Author: 汪俊洪
 * @Date: 2021-06-23 14:15:01
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2023-01-12 10:16:32
 * @Description: 金额格式化
 */

// 只支持小数点后三位以内，四位会有问题
export function formatePrice (num) {
  num = getFullNum(num)
  num += ''
  let numStr = ''
  const arr = num.split('.')
  numStr = arr[0].replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,')
  if (arr.length === 2) {
    numStr += `.${arr[1]}`
  }
  if (numStr === 'null') {
    numStr = 0
  }
  return numStr
}

function getFullNum (num) {
  // 处理非数字
  if (isNaN(num)) { return num };
  // 处理不需要转换的数字
  const str = '' + num
  if (!/e/i.test(str)) { return num };
  return (num).toFixed(18).replace(/\.?0+$/, '')
}
